import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { ContactsTagsDropdown } from 'widgets/ContactsTagsModal'
import type { ImportContactsStore } from 'pages/contacts/ui/ImportContacts/store/ImportContactsStore'
import { PhoneCheckr } from 'pages/contacts/ui/ImportContacts/ui/PhoneCheckr/PhoneCheckr'
import styles from './styles.module.scss'

type IApplyTagsModalActionsProps = {
  importContactsStore: ImportContactsStore
}

export const ApplyTagsModalContent: FC<IApplyTagsModalActionsProps> = observer(
  ({ importContactsStore }) => {
    const {
      contactsTagsModalStore,
      validateNumbers,
      setValidateNumbers,
      openPhoneCheckrDetailsModal,
    } = importContactsStore

    return (
      <>
        <div className={styles.tagBlock}>
          <div className={styles.label}>Tags (Optional)</div>
          <ContactsTagsDropdown contactsTagsModalStore={contactsTagsModalStore} />
        </div>
        <div className={styles.checkrBlock}>
          <PhoneCheckr
            validateNumbers={validateNumbers}
            onToggle={setValidateNumbers}
            onSeeDetails={openPhoneCheckrDetailsModal}
          />
        </div>
      </>
    )
  }
)
